import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin, Twitter } from 'lucide-react';
import { useLang } from '../i18n/LangContext';

const Footer = () => {
	const { t } = useLang();
	return (
		<footer className="bg-slate-900 text-slate-300 py-16">
			<div className="container mx-auto px-6">
				<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
					<div className="col-span-1 lg:col-span-2">
						<Link to="/" className="text-2xl font-bold text-white tracking-tight mb-6 block">
							shopprograms<span className="text-blue-500">.com</span>
						</Link>
						<p className="text-slate-400 max-w-sm mb-6">
							{t.footer.tagline}
						</p>
						<div className="flex space-x-4">
							<a href="https://instagram.com/shopprograms" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram size={20} /></a>
							<a href="https://linkedin.com/company/shopprograms" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-white transition-colors"><Linkedin size={20} /></a>
							<a href="https://twitter.com/shopprograms" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-white transition-colors"><Twitter size={20} /></a>
						</div>
					</div>

					<div>
						<h4 className="text-white font-semibold mb-6">{t.footer.contact}</h4>
						<ul className="space-y-4">
							<li className="flex items-center">
								<Mail size={18} className="mr-3 text-blue-500" />
								<a href="mailto:develop@shopprograms.com" className="hover:text-white transition-colors">develop@shopprograms.com</a>
							</li>
							<li className="flex items-center">
								<Phone size={18} className="mr-3 text-blue-500" />
								<span>+1 347 434 93 14</span>
							</li>
							<li className="flex items-start">
								<MapPin size={18} className="mr-3 text-blue-500 mt-1" />
								<span>pr. Europe Union, 31A,<br />ФОП СОРОЧИНСЬКА ЯО</span>
							</li>
						</ul>
					</div>

					<div>
						<h4 className="text-white font-semibold mb-6">{t.footer.links}</h4>
						<ul className="space-y-2">
							<li><Link to="/#services" className="hover:text-white transition-colors">{t.footer.link_services}</Link></li>
							<li><Link to="/#about" className="hover:text-white transition-colors">{t.footer.link_about}</Link></li>
							<li><Link to="/#contact" className="hover:text-white transition-colors">{t.footer.link_contact}</Link></li>
							<li><Link to="/privacy" className="hover:text-white transition-colors">{t.footer.link_privacy}</Link></li>
						</ul>
					</div>
				</div>

				<div className="border-t border-slate-800 pt-8 text-center text-sm text-slate-500">
					<p>&copy; {new Date().getFullYear()} shopprograms.com. {t.footer.rights}</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
